/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_Gone_BodyInputs */



/**
* | output |
* | --- |
* | "It has expired, was withdrawn or was already used. Ask the person who invited you to send a new one." |
*
* @param {Invite_X15_Gone_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_gone_body = /** @type {((inputs?: Invite_X15_Gone_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Gone_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("It has expired, was withdrawn or was already used. Ask the person who invited you to send a new one.")
});